<template>
  <!-- 附件 -->
  <div>
    <div class="topbox">
      <el-input
        style="width: 100%"
        placeholder="请输入内容"
        v-model.trim="waybillNumber"
      >
        <template slot="append">
          <el-button class="topBtns" @click="getData">查询</el-button>
        </template>
      </el-input>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in tabelHeadeTitle">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'lookFile' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="lookFileBtns(scope.row)">
                查看文件
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
              >
                {{ scope.row.waybillStatusShow }}
              </div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      tableHeigth: "80vh",
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "类型",
          field: "documentStatusShow",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "附件名称",
          field: "fileName",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "附件备注",
          field: "comment",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "查看文件",
          field: "lookFile",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      waybillNumber: "",
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    let waybillNumber = this.$route.query.waybillNumber || "";
    console.log("waybillNumber", waybillNumber);
    if (waybillNumber) {
      this.waybillNumber = waybillNumber;
      this.getData();
    }
  },
  destroyed() {},
  methods: {
    lookFileBtns(row) {
      let id = row.fileId;
      this.$API.wtl_getFileUrl({ fileName: id }).then((res) => {
        let datas = res.data.result.url;
        window.open(datas);
        console.log(datas);
      });
    },

    getData() {
      // 根据运单号获取运单id
      this.$API
        .getWaybillIdByNumber({ waybillNumber: this.waybillNumber })
        .then((res) => {
          let datas = res.data.result || "";
          if (datas && datas.waybillSplitId) {
            let id = datas.waybillSplitId || "";

            this.$API
              .wtl_getWaybillFiles({ waybillSplitId: id })
              .then((res2) => {
                let datas2 = res2.data.result || [];
                this.tableData = datas2;
              });
          }
        });
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
  },
};
</script>
<style scoped lang='less'>
.topbox {
  width: 360px;
  margin-bottom: 10px;
  .topBtns {
    background-color: #ef7c0a;
    color: #fff;
    padding: 7px 20px;
  }
}
</style>